import {BiDownload} from "react-icons/bi";

const DownloadableComponent = ({downloads,onItemClick}) => {
    return (
        <div className="bg-white shadow-lg rounded-2xl p-4 text-center border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800">Download Pooja Guides</h3>
            <p className="text-sm text-gray-600 mb-3">Get detailed guides for various Poojas.</p>

            <div
                className={`grid ${
                    downloads?.length === 1 ? "grid-cols-1 place-items-center" : "grid-cols-2 gap-2"
                }`}
            >
                {downloads?.map((file, index) => (
                        <button
                            onClick={() => onItemClick(file)}
                            key={index}
                            className="w-full bg-BluntRed text-white flex items-center justify-center gap-2 px-4 py-2 rounded-lg hover:bg-red-700 transition">
                            <BiDownload size={18}/> {file?.title}

                        </button>
                ))}
            </div>
        </div>
    );
};


export default DownloadableComponent;